import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { Grid, Stack } from '@mui/material'
import Requests from '../../Requests/Requests'
import { H2, H3 } from 'components/texts/index.js'
import { Button } from 'components/forms/components'
import { Groups as GroupsIcon, InsertDriveFile as FileIcon, Edit as EditIcon } from '@mui/icons-material'
import { RequestGrupoColegio } from 'objects/requests'
import { ModalSelectMeses } from 'components/modals'

export default function Header({ grupo }) {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)

    const onPrintGroupData = () => 
        new RequestGrupoColegio().preliminar(grupo.id)
    
    const generarInforme = (selectedMonth) => {
        new RequestGrupoColegio().informe(selectedMonth)
    }

    useEffect(() => {
        if (open)
            setOpen(false)
    }, [open])

    return (
        <Grid container px={5} py={3} alignItems={"center"}>
            <Grid item xs={6}>
                <Stack>
                    <H2 className="profile-id-text">{"#" + (grupo?.id ?? "0000")}</H2>
                    <H3>{grupo?.clave ?? ""}</H3>
                </Stack>
            </Grid>

            <Grid item xs={6} display={"flex"} justifyContent={"end"}>
                {grupo ?
                    (<Stack spacing={2} direction={"row"}>
                        <Button color={"success"} startIcon={<GroupsIcon />} onClick={onPrintGroupData}>
                            Imprimir datos del grupo
                        </Button>

                        <Button startIcon={<FileIcon />} onClick={() => setOpen(true)}>
                            Generar informe
                        </Button>

                        <Button startIcon={<EditIcon />} variant={"outlined"} onClick={() => navigate('./editar')}>
                            Editar grupo
                        </Button>
                    </Stack>) : null}
            </Grid>

            <ModalSelectMeses open={open} generarInforme={generarInforme} />
        </Grid>
    )
}